// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index_" + {"49":"169ea378811b94b217a9","191":"4c0c69a8107901d0a961"}[chunkId] + "_" + chunkId + ".js";
};